import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Text = styled.div`
  color: ${({ error }) => (error ? COLORS.error : '#fff')};
  line-height: 1.5;
`;

export default Text;
